import { useState, useEffect } from "react";
import {
  Container,
  Grid,
  Table,
  Center,
  Loader,
  Group,
  Pagination,
  Select,
  ActionIcon,
} from "@mantine/core";
import { Link, useLocation, useSearch } from "wouter";
import { getAdminJobs } from "../../api";
import JobStatusBadge from "./JobStatusBadge";
import { IconRefresh } from "@tabler/icons-react";

export default function JobList() {
  const [location, setLocation] = useLocation();
  const query = useSearch();
  const params = new URLSearchParams(query);

  const activePage = parseInt(params.get("page") || "1", 10);
  const statusFilter = params.get("status") || "";

  const [jobs, setJobs] = useState(null);
  const [tenantFilter] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [forceRefresh, setForceRefresh] = useState(0);
  const pageSize = 20;

  const updateFilters = (updates) => {
    const nextParams = new URLSearchParams(query);
    Object.entries(updates).forEach(([key, value]) => {
      if (value) nextParams.set(key, value);
      else nextParams.delete(key);
    });
    const search = nextParams.toString();
    setLocation(search ? `${location}?${search}` : location);
  };

  useEffect(() => {
    setIsLoading(true);
    getAdminJobs(
      activePage,
      pageSize,
      tenantFilter ?? "",
      statusFilter ?? ""
    ).then((data) => {
      setJobs(data);
      setIsLoading(false);
    });
  }, [activePage, statusFilter, tenantFilter, forceRefresh]);

  if (!jobs)
    return (
      <Center mt="xl">
        <Loader size="xl" />
      </Center>
    );

  return (
    <Container px={0}>
      <Grid justify="space-between" gap="2px">
        <Grid.Col span={12}>
          <Group>
            <Pagination
              hideWithOnePage={false}
              total={Math.max(1, Math.ceil(jobs.totalCount / pageSize))}
              value={activePage}
              onChange={(p) => updateFilters({ page: p })}
            />
            {isLoading ? (
              <Loader size="sm" />
            ) : (
              <ActionIcon onClick={() => setForceRefresh(forceRefresh + 1)}>
                <IconRefresh size={16} />
              </ActionIcon>
            )}

            <Select
              clearable
              value={statusFilter}
              onChange={(s) => updateFilters({ status: s, page: 1 })}
              data={["success", "processing", "queued", "failed"]}
            />
          </Group>
          {/* {isLoading && (
            <Center>
              <Loader />
            </Center>
          )} */}

          {/* {jobs.data.map((p) => (
            <Paper>
              <Code block>{JSON.stringify(p, null, 2)}</Code>
            </Paper>
          ))} */}

          <Table stickyHeader stickyHeaderOffset={60}>
            <Table.Thead>
              <Table.Tr>
                <Table.Th>Type</Table.Th>
                <Table.Th>Status</Table.Th>
                <Table.Th>Started</Table.Th>
                <Table.Th>NextRun</Table.Th>
                <Table.Th>RetryCount</Table.Th>
                <Table.Th>User</Table.Th>
              </Table.Tr>
            </Table.Thead>
            <Table.Tbody>
              {jobs.data.map((p) => (
                <Table.Tr
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    window.open(`/admin/jobs/${p.job.id}`, "_blank")
                  }
                  key={p.job.id}
                >
                  <Table.Td>{p.type}</Table.Td>
                  <Table.Td>
                    <JobStatusBadge status={p.job.status} />
                  </Table.Td>
                  <Table.Td>{p.job.started}</Table.Td>
                  <Table.Td>{p.job.nextRun}</Table.Td>
                  <Table.Td>{p.job.retryCount}</Table.Td>
                  <Table.Td>
                    <Link to={`/admin/users/${p.job.userId}`}>
                      {p.job.userId}
                    </Link>
                  </Table.Td>
                </Table.Tr>
              ))}
            </Table.Tbody>
          </Table>
        </Grid.Col>
      </Grid>
    </Container>
  );
}
